export default {
  "debug": true
}